import BaseSettingsApi, { IBasePortalSettings } from 'api/digifi/base/BaseSettingsApi';

export type IIntermediaryPortalSettings = IBasePortalSettings;

export default class IntermediarySettingsApi extends BaseSettingsApi<IIntermediaryPortalSettings> {}
